<template>
  <div class="sec-lucky7-base">
    <h2><img src="/static/img/toppage/todays_lucky7/todays_lucky7_logo.svg" alt="Today's Lucky 7"></h2>
    <span class="update-label"><span>毎日</span><span>更新</span></span>
    <ul>
      <li v-for="(item, index) in items" :key="index">{{item.name}}<span v-if="items.length === index + 1 && itemsReceive.length > limitLen">...他</span></li>
    </ul>
    <span class="link-button" @click="onClickLinkBtn"><span>今日のおすすめを見る</span></span>
  </div>
</template>

<script>
import LinkButton from "./LinkButton";
export default {
  name: "SecTodaysLucky7",
  components: {LinkButton},
  data() {
    return {
      defLimitLen: 3
    }
  },
  props: {
    tagId: {
      type: Number,
      default(){
        return -1
      }
    },
    itemsReceive: {
      type: Array,
      default(){
        return []
      }
    },
    sectionData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    items() {
      let rtnArr = []
      if(this.itemsReceive.length > this.limitLen) {
        for( let i = 0; i < this.limitLen; i++ ) {
          rtnArr.push(this.itemsReceive[i])
        }
      }else{
        rtnArr = this.itemsReceive
      }
      return rtnArr
    },
    limitLen(){
      if(!!this.sectionData && this.sectionData.itemLimit > 0) {
        return this.sectionData.itemLimit
      } else {
        return this.defLimitLen
      }
    }
  },
  methods: {
    onClickLinkBtn() {
      this.$emit('link-click', '/tag/77777')
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.sec-lucky7-base {
  padding: 30px 0 24px;
  background: url('/static/img/toppage/todays_lucky7/todays_lucky7_bg.svg') no-repeat center center;
  background-size: cover;
  h2 {
    margin: 0 0 8px;
    img {
      display: block;
      width: 49.5%;
      margin: auto;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    display: table;
    max-width: 85%;
    margin: 0 auto 16px;
    li {
      font-weight: normal;
      font-size: 12px;
      line-height: 1;
      color: $col_normal_font;
      padding-left: 14px;
      padding-top: 4px;
      padding-bottom: 4px;
      background: url(/static/img/icons/pink_triangle_A.svg) no-repeat left 5px;
      background-size: 8px 11px;
    }
  }
  .link-button {
    background: url(/static/img/toppage/todays_lucky7/grad_btn_frame.svg) no-repeat center center;
    width: 180px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    cursor: pointer;
    & > span {
      color: mix($col_temp_key1, $col_temp_key2);
      font-weight: bold;
      font-size: 13px;
      line-height: 1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .update-label {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 10px;
    right: 10px;
    color: $col_white;
    background: $col_temp_key1;
    border-radius: 30px;
    font-weight: bold;
    font-size: 12px;
    line-height: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @include mq('w320'){
      width: 57px;
      height: 57px;
      font-size: 14px;
      line-height: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecTodaysLucky7.vue